import type { LanguageInfo, SupportedLanguage } from './types';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const SUPPORTED_LANGUAGES: LanguageInfo[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    dir: 'ltr',
    script: 'Latin',
    badge: 'EN',
  },
  {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिन्दी',
    dir: 'ltr',
    script: 'Devanagari',
    badge: 'HI',
  },
  {
    code: 'te',
    name: 'Telugu',
    nativeName: 'తెలుగు',
    dir: 'ltr',
    script: 'Telugu',
    badge: 'TE',
  },
  {
    code: 'or',
    name: 'Odia',
    nativeName: 'ଓଡ଼ିଆ',
    dir: 'ltr',
    script: 'Odia',
    badge: 'OD',
  },
  {
    code: 'bn',
    name: 'Bengali',
    nativeName: 'বাংলা',
    dir: 'ltr',
    script: 'Bengali',
    badge: 'BN',
  },
  {
    code: 'gu',
    name: 'Gujarati',
    nativeName: 'ગુજરાતી',
    dir: 'ltr',
    script: 'Gujarati',
    badge: 'GU',
  },
  {
    code: 'ur',
    name: 'Urdu',
    nativeName: 'اردو',
    dir: 'rtl',
    script: 'Perso-Arabic',
    badge: 'UR',
  },
];

export const LANGUAGE_MAP: Record<SupportedLanguage, LanguageInfo> = SUPPORTED_LANGUAGES.reduce(
  (acc, lang) => {
    acc[lang.code] = lang;
    return acc;
  },
  {} as Record<SupportedLanguage, LanguageInfo>,
);

export function isSupportedLanguage(lang: unknown): lang is SupportedLanguage {
  if (typeof lang !== 'string') return false;
  return SUPPORTED_LANGUAGES.some((l) => l.code === lang);
}

export function getLanguageConfig(code: SupportedLanguage): LanguageInfo {
  return LANGUAGE_MAP[code] || LANGUAGE_MAP[DEFAULT_LANGUAGE];
}

